import { render, staticRenderFns } from "./TOOL_MANAGEMENT_REGISTER.vue?vue&type=template&id=258b08c0&scoped=true"
import script from "./TOOL_MANAGEMENT_REGISTER.vue?vue&type=script&lang=ts"
export * from "./TOOL_MANAGEMENT_REGISTER.vue?vue&type=script&lang=ts"
import style0 from "./TOOL_MANAGEMENT_REGISTER.vue?vue&type=style&index=0&id=258b08c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258b08c0",
  null
  
)

export default component.exports